/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessBean', 'model/StripeCustomerBean', 'model/StripeSubscriptionBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BusinessBean'), require('./StripeCustomerBean'), require('./StripeSubscriptionBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.LoginResponse = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.BusinessBean, root.BpmbuildUatDsappspotcom.StripeCustomerBean, root.BpmbuildUatDsappspotcom.StripeSubscriptionBean);
  }
}(this, function(ApiClient, BusinessBean, StripeCustomerBean, StripeSubscriptionBean) {
  'use strict';

  /**
   * The LoginResponse model module.
   * @module model/LoginResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LoginResponse</code>.
   * @alias module:model/LoginResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>LoginResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LoginResponse} obj Optional instance to populate.
   * @return {module:model/LoginResponse} The populated <code>LoginResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('attributeTypes'))
        obj.attributeTypes = ApiClient.convertToType(data['attributeTypes'], ['String']);
      if (data.hasOwnProperty('attributeUsageTypes'))
        obj.attributeUsageTypes = ApiClient.convertToType(data['attributeUsageTypes'], ['String']);
      if (data.hasOwnProperty('authenticateProvider'))
        obj.authenticateProvider = ApiClient.convertToType(data['authenticateProvider'], 'String');
      if (data.hasOwnProperty('businessList'))
        obj.businessList = ApiClient.convertToType(data['businessList'], [BusinessBean]);
      if (data.hasOwnProperty('businessTypeList'))
        obj.businessTypeList = ApiClient.convertToType(data['businessTypeList'], [BusinessBean]);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('consultantTypeList'))
        obj.consultantTypeList = ApiClient.convertToType(data['consultantTypeList'], [BusinessBean]);
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('facebookId'))
        obj.facebookId = ApiClient.convertToType(data['facebookId'], 'String');
      if (data.hasOwnProperty('firstName'))
        obj.firstName = ApiClient.convertToType(data['firstName'], 'String');
      if (data.hasOwnProperty('flowItemStatusTypes'))
        obj.flowItemStatusTypes = ApiClient.convertToType(data['flowItemStatusTypes'], ['String']);
      if (data.hasOwnProperty('globalBid'))
        obj.globalBid = ApiClient.convertToType(data['globalBid'], 'String');
      if (data.hasOwnProperty('languageId'))
        obj.languageId = ApiClient.convertToType(data['languageId'], 'String');
      if (data.hasOwnProperty('messageList'))
        obj.messageList = ApiClient.convertToType(data['messageList'], 'String');
      if (data.hasOwnProperty('operationalTypes'))
        obj.operationalTypes = ApiClient.convertToType(data['operationalTypes'], ['String']);
      if (data.hasOwnProperty('pin'))
        obj.pin = ApiClient.convertToType(data['pin'], 'String');
      if (data.hasOwnProperty('productTypes'))
        obj.productTypes = ApiClient.convertToType(data['productTypes'], ['String']);
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('roleType'))
        obj.roleType = ApiClient.convertToType(data['roleType'], 'String');
      if (data.hasOwnProperty('stationOperationalStatus'))
        obj.stationOperationalStatus = ApiClient.convertToType(data['stationOperationalStatus'], ['String']);
      if (data.hasOwnProperty('stockTypes'))
        obj.stockTypes = ApiClient.convertToType(data['stockTypes'], ['String']);
      if (data.hasOwnProperty('stripeCustomer'))
        obj.stripeCustomer = StripeCustomerBean.constructFromObject(data['stripeCustomer']);
      if (data.hasOwnProperty('subscriptionList'))
        obj.subscriptionList = ApiClient.convertToType(data['subscriptionList'], [StripeSubscriptionBean]);
      if (data.hasOwnProperty('surname'))
        obj.surname = ApiClient.convertToType(data['surname'], 'String');
      if (data.hasOwnProperty('twitterId'))
        obj.twitterId = ApiClient.convertToType(data['twitterId'], 'String');
      if (data.hasOwnProperty('userEmail'))
        obj.userEmail = ApiClient.convertToType(data['userEmail'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('userName'))
        obj.userName = ApiClient.convertToType(data['userName'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<String>} attributeTypes
   */
  exports.prototype.attributeTypes = undefined;

  /**
   * @member {Array.<String>} attributeUsageTypes
   */
  exports.prototype.attributeUsageTypes = undefined;

  /**
   * @member {String} authenticateProvider
   */
  exports.prototype.authenticateProvider = undefined;

  /**
   * @member {Array.<module:model/BusinessBean>} businessList
   */
  exports.prototype.businessList = undefined;

  /**
   * @member {Array.<module:model/BusinessBean>} businessTypeList
   */
  exports.prototype.businessTypeList = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Array.<module:model/BusinessBean>} consultantTypeList
   */
  exports.prototype.consultantTypeList = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} facebookId
   */
  exports.prototype.facebookId = undefined;

  /**
   * @member {String} firstName
   */
  exports.prototype.firstName = undefined;

  /**
   * @member {Array.<String>} flowItemStatusTypes
   */
  exports.prototype.flowItemStatusTypes = undefined;

  /**
   * @member {String} globalBid
   */
  exports.prototype.globalBid = undefined;

  /**
   * @member {String} languageId
   */
  exports.prototype.languageId = undefined;

  /**
   * @member {String} messageList
   */
  exports.prototype.messageList = undefined;

  /**
   * @member {Array.<String>} operationalTypes
   */
  exports.prototype.operationalTypes = undefined;

  /**
   * @member {String} pin
   */
  exports.prototype.pin = undefined;

  /**
   * @member {Array.<String>} productTypes
   */
  exports.prototype.productTypes = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {String} roleType
   */
  exports.prototype.roleType = undefined;

  /**
   * @member {Array.<String>} stationOperationalStatus
   */
  exports.prototype.stationOperationalStatus = undefined;

  /**
   * @member {Array.<String>} stockTypes
   */
  exports.prototype.stockTypes = undefined;

  /**
   * @member {module:model/StripeCustomerBean} stripeCustomer
   */
  exports.prototype.stripeCustomer = undefined;

  /**
   * @member {Array.<module:model/StripeSubscriptionBean>} subscriptionList
   */
  exports.prototype.subscriptionList = undefined;

  /**
   * @member {String} surname
   */
  exports.prototype.surname = undefined;

  /**
   * @member {String} twitterId
   */
  exports.prototype.twitterId = undefined;

  /**
   * @member {String} userEmail
   */
  exports.prototype.userEmail = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} userName
   */
  exports.prototype.userName = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/LoginResponse.js